<template>
  <section>
  <!-- banner部分 -->
    <v-sub_banner :msgObj="subBannerInfo"></v-sub_banner>
    <!-- 简介部分 -->
    <b-container fluid>
      <b-row class="justify-content-center abouts-us-content">
        <b-col
          cols="12"
          class="text-center flex-column justify-content-center d-flex"
        >
          <b-container fluid>
            <b-row class="justify-content-center">
              <b-col
                cols="10"
                md="9"
                lg="8"
                class="text-center flex-column justify-content-center d-flex abouts-us-bg"
              >
                <h1 id="imgbox">
                  <img
                    src="@/assets/images/about-us/about-us-vlogo.png"
                    alt=""
                  />
              
                </h1>
                <br />
                <br />
                <div>
                  <p>
                    中国民用航空局信息中心是经中央机构编制委员会办公室批准成立的中国民用航空局直属事业单位，于2006年正式挂牌运行，现为正司局级规格。
                  </p>
                  <p>
                    作为民航电子政务、民航大数据和民航信息化建设的主力军，信息中心主要职责如下：
                  </p>
                  <br />
                  <br />
                  <p>1、受民航局委托，研究拟订民航电子政务、民航大数据及民航信息化的发展政策、规章、标准和规范制度，研究拟订民航电子政务及民航大数据建设的整体发展规划；</p>
                  <p>
                    2、承担民航电子政务基础设施、基础应用平台、网络安全保障体系的建设与运行管理工作，承担民航政务信息系统的建设、整合、运行保障、应用推广、技术支持等工作；
                  </p>
                  <p>
                    3、承担民航大数据中心规划、建设、管理与集约利用，统筹推进民航大数据有关行业云、安全体系建设和安全保障工作，以及民航数据汇聚、整合、治理、共享、挖掘、应用、对外合作服务等智慧民航建设相关工作；
                  </p>
                  <p>
                    4、承担民航行政机构信息化建设的技术支持工作；
                  </p>
                  <p>
                    5、承担民航行业信息化、网络安全新技术、新产品、新业态的研究工作，开展相关技术开发、技术转让、技术服务、技术咨询及技术培训等工作；
                  </p>
                  <p>
                    6、完成民航局交办的其他工作。
                  </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>
<script>
import Sub_banner from "../sub-banner.vue";
export default {
  components: {
    "v-sub_banner": Sub_banner,
  },
  data() {
    return {
      subBannerInfo:{
        img:require("@/assets/images/connect_banner.png"),
        title:'中心简介',
        subTitle:'About us'
      },
      screenWidth: 0,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.screenWidth = window.innerWidth;
    this.setReSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setReSize();
    };
  },
  methods: {
    setReSize(){
      if (this.screenWidth > 576) {
        this.subBannerInfo.img=require("@/assets/images/connect_banner.png");
      } else {
        this.subBannerInfo.img = require("@/assets/images/common_m.png");
      }
      
    },
  },
};
</script>
<style>
@import "../../assets/css/about-us.css";
</style>
<style lang="less" scoped>
@media (max-width: 575px) {
  .abouts-us-content p {
    font-size: 14px;
    line-height: 2.3;
    text-align: justify;
  }
  .abouts-us-content img{
      width: 60%;
    }
  #imgbox {
  -webkit-box-reflect: below -5px -webkit-linear-gradient(bottom, rgba(255,255,255,0.1) 0%, transparent 38%, transparent 100%);
  }
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) and (max-width: 767px) {
  .abouts-us-content p {
    font-size: 15px;
    line-height: 2.4;
  }

}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) and (max-width: 991px) {
  .abouts-us-content p {
    font-size: 15px;
    line-height: 2.5;
  }

}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) and (max-width: 1199px) {

  .abouts-us-content p {
    font-size: 15px;
    line-height: 2.5;
  }

}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {
  .abouts-us-bg{
    padding: 3% 1% 10%;
  }
 
}
</style>
